import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'WaterTakeReadings';

export type WaterTakeReadingsProps = {
  waterTakeState?: number;
  takeFlowRate?: number;
  waterVolumeTakenLastPeriod?: number;
  waterVolumeTakenCurrentPeriod?: number;
  cumulativeWaterVolumeTaken?: number;
};

export class WaterTakeReadings extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  waterTakeState?: number;
  takeFlowRate?: number;
  waterVolumeTakenLastPeriod?: number;
  waterVolumeTakenCurrentPeriod?: number;
  cumulativeWaterVolumeTaken?: number;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      waterTakeState: {
        type: 'Number',
        editable: true,
        label: 'Water Take State',
        name: 'waterTakeState',
        description: 'Take Meter taking water or not in period',
      },
      takeFlowRate: {
        type: 'Number',
        editable: true,
        label: 'Take Flow Rate',
        name: 'takeFlowRate',
        description: 'Water flow rate through the Water Take litres/ sec and cubic metres/ sec',
      },
      waterVolumeTakenLastPeriod: {
        type: 'Number',
        editable: true,
        label: 'Water Volume Taken Last Period',
        name: 'waterVolumeTakenLastPeriod',
        description: 'Water Volume Taken through the Water Take in the current period',
      },
      waterVolumeTakenCurrentPeriod: {
        type: 'Number',
        editable: true,
        label: 'Water Volume Taken Current Period',
        name: 'waterVolumeTakenCurrentPeriod',
        description: 'Water Volume Taken through the Water Take in the last period',
      },
      cumulativeWaterVolumeTaken: {
        type: 'Number',
        editable: true,
        label: 'Cumulative Water Volume Taken',
        name: 'cumulativeWaterVolumeTaken',
        description: 'Cumulative Water Volume Taken through the Water Take ',
      },
    };
  };
}
